import { Tag, type TagColor } from '@leland-dev/leland-ui-library';
import React from 'react';

import {
  OrganizationImg,
  type OrganizationType,
} from '../common/OrganizationImg';

export interface OrganizationTagDetails {
  organization: {
    name: string;
    logoLink?: Nullable<string>;
  };
  text?: string;
  tagColor?: TagColor;
}

interface OrganizationTagProps {
  tagDetails: OrganizationTagDetails;
  type: OrganizationType;
  className?: string;
}

const OrganizationTag: React.FC<OrganizationTagProps> = ({
  tagDetails,
  type,
  className,
}) => {
  return (
    <div className={className}>
      <Tag
        CustomLeftIcon={() => (
          <OrganizationImg
            small
            nonSizeClassName="shrink-0 rounded-full"
            pictureLink={tagDetails.organization.logoLink}
            name={tagDetails.organization.name}
            type={type}
          />
        )}
        text={tagDetails.text ?? tagDetails.organization.name}
        tagColor={tagDetails.tagColor}
      />
    </div>
  );
};

export default OrganizationTag;
